var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGsaAdvantage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.313,
    height: 38.471,
    viewBox: "0 0 136.313 38.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4759",
    "data-name": "Group 4759",
    transform: "translate(-527 -2997.726)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4231",
    "data-name": "Group 4231",
    transform: "translate(660.512 3020.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6085",
    "data-name": "Path 6085",
    d: "M883.383,292.719a.433.433,0,0,0,.429-.437.4.4,0,0,0-.236-.346.971.971,0,0,0-.41-.05h-.517v1.505h.243v-.639h.145c.186,0,.255.065.448.4l.133.236h.3l-.183-.293C883.58,292.856,883.5,292.765,883.383,292.719Zm-.194-.175h-.3v-.452h.277c.281,0,.384.057.384.224S883.44,292.545,883.189,292.545Z",
    transform: "translate(-881.863 -291.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6086",
    "data-name": "Path 6086",
    d: "M880.378,288.764a1.4,1.4,0,1,0,1.4,1.4A1.4,1.4,0,0,0,880.378,288.764Zm0,2.569a1.169,1.169,0,1,1,1.167-1.171A1.171,1.171,0,0,1,880.378,291.333Z",
    transform: "translate(-878.976 -288.764)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4758",
    "data-name": "Group 4758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6082",
    "data-name": "Path 6082",
    d: "M188.414,204.936v38.471H226.83V204.936Zm9.317,30.292a7.365,7.365,0,0,0,1.772-.169v-3.2H197.18v-1.8h4.4v6.426a11.472,11.472,0,0,1-3.869.58c-3.9,0-6.51-2.519-6.51-6.441a6.162,6.162,0,0,1,6.527-6.337,9.463,9.463,0,0,1,3.706.653l-.169,2.131a5.578,5.578,0,0,0-3.451-.948,4.555,4.555,0,0,0-.086,9.106Zm10.286-6.014c1.793.895,3.629,1.629,3.629,4.1,0,2.7-2.12,3.827-4.566,3.748a9.436,9.436,0,0,1-2.635-.548l.209-1.943a7.3,7.3,0,0,0,2.636.655c1.1-.017,2.209-.53,2.209-1.809,0-.985-.789-1.469-1.552-1.856-1.687-.855-3.628-1.45-3.628-3.84,0-2.26,1.8-3.437,4.027-3.437a8.387,8.387,0,0,1,2.748.484l-.291,1.914a5.6,5.6,0,0,0-2.387-.561c-.961,0-1.949.337-1.949,1.446C206.466,228.434,207.355,228.883,208.017,229.214Zm9.026,2.851-1.086,2.481,2.609-1.367,1.5,1.156-5.137,2.513h-2.115l2.757-6.16Zm-1.436-1.454,2.963-6.6,2.962,6.6h-2.064l-.9-2.193-.9,2.193Zm6.55,6.236-2.061-4.783,1.47-1.377,2.757,6.16Z",
    transform: "translate(338.586 2792.79)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4236",
    "data-name": "Group 4236",
    transform: "translate(572.925 3016.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4235",
    "data-name": "Group 4235",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6107",
    "data-name": "Path 6107",
    d: "M404.118,287.885h2.5l2.208,12.171h-2.139l-.435-2.626H401.25l-1.339,2.626h-2.33Zm-2,7.859H406l-.922-5.668h-.035Z",
    transform: "translate(-397.581 -286.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6108",
    "data-name": "Path 6108",
    d: "M462.808,292.16c0-3.286,2-5.772,4.66-5.772a3.5,3.5,0,0,1,2.5,1.008l.852-4.764h2l-2.312,13.127h-1.617l.07-1.374a3.681,3.681,0,0,1-3.008,1.547C464.3,295.933,462.808,294.646,462.808,292.16Zm6.294.261.626-3.651a2.9,2.9,0,0,0-2.017-.835c-1.652,0-2.851,1.791-2.851,4.068,0,1.739.73,2.382,1.634,2.382C467.5,294.386,468.372,293.6,469.1,292.421Z",
    transform: "translate(-450.933 -282.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6109",
    "data-name": "Path 6109",
    d: "M517.528,304.216h1.878l.991,6.99h.035l3.408-6.99h2.087l-4.712,9.2h-2.225Z",
    transform: "translate(-495.691 -300.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6110",
    "data-name": "Path 6110",
    d: "M559.549,308.912c0-3.339,2.034-5.842,4.695-5.842a3.4,3.4,0,0,1,2.573,1.165l.261-.956h1.791l-1.2,6.763a3.607,3.607,0,0,0-.052.452c0,.435.243.574.713.574l-.243,1.443c-1.339,0-2.139-.365-2.295-1.391a3.718,3.718,0,0,1-3.043,1.565C561.027,312.685,559.549,311.381,559.549,308.912Zm6.92-3.425a2.887,2.887,0,0,0-2.017-.835c-1.634,0-2.852,1.773-2.852,4.1,0,1.669.713,2.347,1.617,2.347,1.043,0,1.9-.8,2.625-1.965Z",
    transform: "translate(-530.062 -299.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6111",
    "data-name": "Path 6111",
    d: "M617.551,306.756a6.185,6.185,0,0,0,.1-.956.886.886,0,0,0-.991-1.008c-.974,0-1.947.835-2.921,2.191l-.991,5.651h-2.017l1.6-9.2H614l-.052,1.582a4.179,4.179,0,0,1,3.269-1.756,2.251,2.251,0,0,1,2.451,2.33,9.522,9.522,0,0,1-.156,1.478l-1.008,5.564h-2Z",
    transform: "translate(-571.929 -299.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6112",
    "data-name": "Path 6112",
    d: "M666.128,294.636H664.6l.261-1.513h1.513l.435-2.469h2l-.435,2.469h2.521l-.243,1.513H668.11l-.817,4.608a6.545,6.545,0,0,0-.087.887c0,.522.226.765.747.765a2.746,2.746,0,0,0,1.409-.522l.661,1.408a4.893,4.893,0,0,1-2.538.748,2.081,2.081,0,0,1-2.312-2.069,8.813,8.813,0,0,1,.174-1.478Z",
    transform: "translate(-615.986 -289.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6113",
    "data-name": "Path 6113",
    d: "M697.163,308.912c0-3.339,2.034-5.842,4.695-5.842a3.4,3.4,0,0,1,2.573,1.165l.261-.956h1.791l-1.2,6.763a3.572,3.572,0,0,0-.052.452c0,.435.243.574.713.574l-.243,1.443c-1.339,0-2.139-.365-2.3-1.391a3.718,3.718,0,0,1-3.043,1.565C698.641,312.685,697.163,311.381,697.163,308.912Zm6.92-3.425a2.887,2.887,0,0,0-2.017-.835c-1.635,0-2.852,1.773-2.852,4.1,0,1.669.713,2.347,1.617,2.347,1.043,0,1.9-.8,2.625-1.965Z",
    transform: "translate(-642.622 -299.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6114",
    "data-name": "Path 6114",
    d: "M753.716,311.207a3.541,3.541,0,0,1-2.921,1.5c-1.513,0-3.025-1.13-3.025-3.756,0-3.355,2.087-5.685,4.677-5.685a3.424,3.424,0,0,1,2.573,1.1l.261-.921h1.808l-1.617,9.111c-.382,2.208-1.53,3.738-4.555,3.738a5.749,5.749,0,0,1-3.616-1.339l1.078-1.339a4.486,4.486,0,0,0,2.678,1.061c1.356,0,2.139-.626,2.469-2.452Zm.974-5.564a2.928,2.928,0,0,0-2.034-.835c-1.582,0-2.834,1.791-2.834,4.068,0,1.634.748,2.278,1.6,2.278,1.078,0,1.878-.765,2.66-1.947Z",
    transform: "translate(-683.632 -299.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6115",
    "data-name": "Path 6115",
    d: "M807.548,303.07c1.982,0,3.217,1.165,3.217,2.486,0,1.808-2.121,2.764-5.338,2.764h-1.339v.3c0,1.652.765,2.434,2.156,2.434a5.016,5.016,0,0,0,2.556-.835l.782,1.356a6.184,6.184,0,0,1-3.6,1.113,3.76,3.76,0,0,1-3.964-4A5.475,5.475,0,0,1,807.548,303.07Zm-3.147,3.808h1.183c2.365,0,3.164-.626,3.164-1.322,0-.539-.5-.974-1.356-.974A3.347,3.347,0,0,0,804.4,306.878Z",
    transform: "translate(-728.389 -299.349)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6116",
    "data-name": "Path 6116",
    d: "M850.784,298.022h2.26l-.348,2.034h-2.26Zm1.513-7.929.4-2.208h2.087l-.4,2.208-1.652,6.294h-1.061Z",
    transform: "translate(-767.991 -286.929)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsaAdvantage);
export default __webpack_public_path__ + "static/media/gsa-advantage.33fdaeb25d5a3daf0012bb2f5733b1b5.svg";
export { ForwardRef as ReactComponent };